import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './redux/store';
import 'react-toastify/dist/ReactToastify.css';
import './styles/styles.scss';
import './i18n';
import { Loader } from './components';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
ReactDOM.createRoot(document.getElementById('root')).render(
// <React.StrictMode>
_jsx(React.Suspense, Object.assign({ fallback: _jsx("div", Object.assign({ className: "vh-100 flex justify-content-center align-items-center" }, { children: _jsx(Loader, {}) })) }, { children: _jsx(ErrorBoundary, Object.assign({ place: "app" }, { children: _jsx(Provider, Object.assign({ store: store }, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) })) })) }))
// </React.StrictMode>
);
